import { createFileRoute } from '@tanstack/react-router'
import { MemoryScreen } from '../features/memory/MemoryScreen'
import { validateMemorySearch } from '../features/memory/memoryRoute'

function Memory() {
  const { workspaceId } = Route.useParams()
  return <MemoryScreen workspaceId={workspaceId} />
}

export const Route = createFileRoute('/w/$workspaceId/memory')({
  validateSearch: validateMemorySearch,
  component: Memory,
})
